import axios from "axios";
import Semaforo from "@/models/Semaforo.model.js";

const API_URL = process.env.VUE_APP_API_URL;

class SemaphoreService{

    getSemaforoById(token, idSemaforo){     
       
        return axios({
            method: 'get',
            url: API_URL + 'semafori/getsemaforobyid', 
            params:{
                idSemaforo: idSemaforo
            },           
            headers:{
                    Authorization: 'Bearer '+ token,
                    'Content-Type': 'application/json'
            }            
        }).then(
            data =>  {               
                if(data.status == 401){
                    return null;
                }
                else{                  
                    return Object.assign(new Semaforo(), data.data);
                }               
            }
        )
        .catch(error => {return error;});            
    }
}

export default new SemaphoreService();